import { RequestServerClass } from '../../util/request';
import publishObjectPath from '@/util/configRegistry';
import { changePostParam } from '@/util/changePostParam';

const serverUrl = publishObjectPath.serverUrl;
const qs = require('qs');
const conttype = 'application/x-www-form-urlencoded';

export class PerformanceServer {
  public rSerivce: any;

  constructor(opt: any, axiosFilterFn?: any) {
    this.rSerivce = new RequestServerClass(opt);
    axiosFilterFn.call(this, this.rSerivce.serverObj);
  }

  // 责任履职
  // 分页查询所有数据
  public getPerformanceList(opts: object) {
    const url = serverUrl + '/api/yunnan/dutyTask/list/page/tree';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 新增数据
  public addPerformanceData(opts: object) {
    const url = serverUrl + '/api/yunnan/dutyTask/create';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 通过主键查询单条数据详情
  public getSinglePerformanceData(id: any) {
    const url = serverUrl + `/api/yunnan/dutyTask/${id}`;
    return this.rSerivce.serverObj.get(url);
  }
  // 编辑数据
  public editPerformanceData(id: any, opts: object) {
    const url = serverUrl + `/api/yunnan/dutyTask/edit/${id}`;
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 获取签名图片
  public getValidatorCode(id: any) {
    const url = serverUrl + `/api/spaceManage/staffSignature/byId/${id}`;
    return this.rSerivce.serverObj.get(url);
  }

  // 获取签名人信息
  public getStaffInfo(id: any) {
    const url = serverUrl + `/api/spaceManage/staffSignature/byId/staffInfo/${id}`;
    return this.rSerivce.serverObj.get(url);
  }

  // 删除 责任履职数据
  public deletePerformanceList(idList: any, remark: any) {
    if (idList instanceof Array) {
      idList = idList.join(',');
    }
    const url = serverUrl + '/api/yunnan/dutyTask?idList=' + idList + '&remark=' + remark;
    return this.rSerivce.serverObj.delete(url, {
      params: idList,
    });
  }

  // 完成 责任履职
  public finishPerformanceList(id: any, opts: any) {
    const url = serverUrl + `/api/yunnan/dutyTask/handleRegister/${id}`;
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 附件补充
  public supplementEnclosure(id: any, opts: any) {
    const url = serverUrl + `/api/yunnan/dutyTask/annex/supplement/${id}`;
    return this.rSerivce.serverObj.post(url, opts);
  }

  public getSiteAllByAuth(opts: object) {
    const url = serverUrl + '/api/yunnan/workTicketConfig/all';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 获取职务数据
  public getSpacePostByAuth(opts: object) {
    const url = serverUrl + '/api/spaceManage/spacePost/all';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 获取任务列表
  public getTagManageList(opts: object) {
    const url = serverUrl + '/api/sysManage/tagManage/all';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  /*  ↓ 检查考核 -> 安全检查 ↓ */

  // 分页查询所有数据
  public getList(opts: object) {
    const url = serverUrl + '/api/yunnan/security-check/task/list';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 新增检查 -> 选择模板
  public getTemplateAll() {
    const url = serverUrl + '/api/yunnan/security-check/template/all';
    return this.rSerivce.serverObj.get(url);
  }

  // 新增检查 -> 选择对应的模板 -> 待渲染的单条数据的接口
  public getSingleTemplate(id: any) {
    const url = serverUrl + `/api/yunnan/security-check/template/${id}`;
    return this.rSerivce.serverObj.get(url);
  }

  // 新增检查 -> 保存
  public addTask(opts: object) {
    const url = serverUrl + '/api/yunnan/security-check/task';
    return this.rSerivce.serverObj.post(url, opts);
  }
  // 新增检查 -> 编辑
  public editTask(opts: object) {
    const url = serverUrl + '/api/yunnan/security-check/task';
    return this.rSerivce.serverObj.put(url, opts);
  }

  // 检查页面 详情
  // 查询安全检查任务详情
  public getTemplateDetail(id: any) {
    const url = serverUrl + `/api/yunnan/security-check/task/${id}`;
    return this.rSerivce.serverObj.get(url);
  }

  // 检查页面 添加隐患 保存接口
  // 添加安全检查隐患
  public addHazard(opts: object) {
    const url = serverUrl + '/api/yunnan/security-check/hazard';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 根据安全检查任务id获取安全检查隐患整改单列表
  public getRectifyFormDetail(taskId: any) {
    const url = serverUrl + '/api/yunnan/security-check/rectify-form/task-id/' + taskId;
    return this.rSerivce.serverObj.get(url);
  }

  // 整改单详情
  public getRectifyForm(id: any) {
    const url = serverUrl + '/api/yunnan/security-check/rectify-form/' + id;
    return this.rSerivce.serverObj.get(url);
  }

  // 创建整改单
  public createForm(opts: object) {
    const url = serverUrl + '/api/yunnan/security-check/rectify-form/create';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 修改整改单
  public editRectifyForm(opts: object) {
    const url = serverUrl + '/api/yunnan/security-check/rectify-form/update';
    return this.rSerivce.serverObj.put(url, opts);
  }

  // 完成安全检查任务
  public finishForm(opts: any) {
    const url = serverUrl + '/api/yunnan/security-check/task/finish' + changePostParam(opts);
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 删除安全检查任务
  public deleteTask(id: object) {
    const url = serverUrl + '/api/yunnan/security-check/task/' + id;
    return this.rSerivce.serverObj.delete(url);
  }

  // 获取图片的接口
  public getSysFile(ids: any) {
    const url = serverUrl + '/api/sysManage/sysFile?ids=' + ids;
    return this.rSerivce.serverObj.get(url);
  }
  // 安全检查隐患删除
  public delSecurityCheckHazard(id: any) {
    const url = serverUrl + `/api/yunnan/security-check/hazard/${id}`;
    return this.rSerivce.serverObj.delete(url);
  }
  // 安全检查隐患 详情
  public infoSecurityCheckHazard(id: any) {
    const url = serverUrl + `/api/yunnan/security-check/hazard/${id}`;
    return this.rSerivce.serverObj.get(url);
  }
  // 安全检查隐患 编辑
  public editSecurityCheckHazard(id: any, opts: any) {
    const url = serverUrl + `/api/yunnan/security-check/hazard/${id}`;
    return this.rSerivce.serverObj.put(url, opts);
  }

  /*  ↑ 安环检查 -> 检查清单 ↑  */

  // 安环检查检查模板star

  // 获取数据
  public getTheirList() {
    const url = serverUrl + '/api/yunnan/security-check/template/all';
    return this.rSerivce.serverObj.get(url);
  }

  // 根据模板名称查询
  public FindTheirList(opts: any) {
    const url = serverUrl + '/api/yunnan/security-check/template/all';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 删除数据
  public deleteTheirList(id: any) {
    const url = serverUrl + '/api/yunnan/security-check/template/' + id;
    return this.rSerivce.serverObj.delete(url);
  }

  // 关联项表格
  public relevanceData() {
    const url = serverUrl + '/api/yunnan/security-check/standard-item/relation-item';
    return this.rSerivce.serverObj.get(url);
  }

  // 关联项表格
  public bindRelevanceData(opt: any) {
    const url = serverUrl + '/api/yunnan/security-check/standard-item/bind-relation';
    return this.rSerivce.serverObj.post(url, opt);
  }

  // 新增检查项模板
  public addRelevanceData(opt: any) {
    const url = serverUrl + '/api/yunnan/security-check/template';
    return this.rSerivce.serverObj.post(url, opt);
  }

  //获取自定义检查模板树形数据
  public customRelevanceData(opt: any) {
    const url = serverUrl + '/api/sysManage/tagManage/list/all/tree';
    return this.rSerivce.serverObj.get(url, { params: opt });
  }

  //确定自定义检查模板
  public confrimCustomRelevanceData(opt: any) {
    const url = serverUrl + '/api/yunnan/security-check/standard-item/custom-item';
    return this.rSerivce.serverObj.post(url, opt);
  }

  //根据id获取单条数据
  public getDetail(id: any) {
    const url = serverUrl + '/api/yunnan/security-check/template/' + id;
    return this.rSerivce.serverObj.get(url);
  }

  // 修改检查项模板
  public editDetail(opt: any, id: any) {
    const url = serverUrl + '/api/yunnan/security-check/template/' + id;
    return this.rSerivce.serverObj.put(url, opt);
  }

  // 安环检查检查模板end

  // 检查标准end

  // 检查考核 -> 考核标准
  // 分页查询所有数据
  public getAssessStandConfig(opts: object) {
    const url = serverUrl + '/api/yunnan/assessStandConfig';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 获取任务列表 - 字典...
  public getProjectMap(opts: object) {
    const url = serverUrl + '/api/yunnan/assessStandConfig/getProjectMap';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  public getByDepartments(opts: any) {
    const url = serverUrl + '/api/yunnan/assessDepartmentConfig/getByDepartments';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 新增
  public addAssessStandConfig(opt: any) {
    const url = serverUrl + '/api/yunnan/assessStandConfig';
    return this.rSerivce.serverObj.post(url, opt);
  }

  // 修改
  public modifyAssessStandConfig(opt: any) {
    const url = serverUrl + '/api/yunnan/assessStandConfig';
    return this.rSerivce.serverObj.put(url, opt);
  }

  // 删除
  public deleteAssessStandConfig(id: any) {
    const url = serverUrl + '/api/yunnan/assessStandConfig?idList=' + id;
    return this.rSerivce.serverObj.delete(url);
  }

  // 责任履职规则清单模块
  // 分页查询所有数据
  public getDutyRuleList(opts: object) {
    // const url = serverUrl + '/api/yunnan/dutyRuleList';
    const url = serverUrl + '/api/yunnan/dutyRuleList/selectPage';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 删除
  public deleteDutyRuleList(id: any) {
    const url = serverUrl + '/api/yunnan/dutyRuleList?idList=' + id;
    return this.rSerivce.serverObj.delete(url);
  }

  // 新增
  public addDutyRuleList(opt: any) {
    const url = serverUrl + '/api/yunnan/dutyRuleList';
    return this.rSerivce.serverObj.post(url, opt);
  }

  // 修改
  public editDutyRuleList(opt: any) {
    const url = serverUrl + '/api/yunnan/dutyRuleList';
    return this.rSerivce.serverObj.put(url, opt);
  }

  // 查询详情
  public getDutyRuleListDetail(id: any) {
    const url = serverUrl + `/api/yunnan/dutyRuleList/${id}`;
    return this.rSerivce.serverObj.get(url);
  }

  // 生成任务
  public dutyRuleListCreateTask(opts: object, id: any) {
    const url = serverUrl + '/api/yunnan/dutyRuleList/create/task/' + id;
    return this.rSerivce.serverObj.post(url, opts);
  }
  //  创建任务前获取时间段
  public dutyRuleListCreateTaskBeforeTime(id: any) {
    const url = serverUrl + '/api/yunnan/dutyRuleList/createTask/beforeTime/' + id;
    return this.rSerivce.serverObj.get(url);
  }
  // 批量生成任务 获取数据
  public batchCreateDutyRuleData(opts: object) {
    const url = serverUrl + '/api/yunnan/dutyRuleList/get/batch/create/task/data';
    return this.rSerivce.serverObj.post(url, opts);
  }
  // 批量生成任务 保存数据
  public batchCreateDutyRuleCreateData(opts: object) {
    const url = serverUrl + '/api/yunnan/dutyRuleList/batch/create/task';
    return this.rSerivce.serverObj.post(url, opts);
  }

  /*  ↓ 检查考核 -> 整改通知单 ↓ */

  // 分页数据 我整改的
  public receiverListRectifyForm(opts: object) {
    const url = serverUrl + '/api/yunnan/security-check/rectify-form/receiver-list';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  // 分页数据 我整改的
  public sponsorListRectifyForm(opts: object) {
    const url = serverUrl + '/api/yunnan/security-check/rectify-form/creator-list';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  // 详情
  public detailRectifyForm(id: string) {
    const url = serverUrl + `/api/yunnan/security-check/rectify-form/${id}`;
    return this.rSerivce.serverObj.get(url);
  }
  // 删除
  public deleteRectifyForm(id: string) {
    const url = serverUrl + `/api/yunnan/security-check/rectify-form/${id}`;
    return this.rSerivce.serverObj.delete(url);
  }

  // 反馈
  public feedbackHazard(opts: object) {
    const url = serverUrl + '/api/yunnan/security-check-hazard/flow-processor/create-hazard-rectify-feedback-form';
    return this.rSerivce.serverObj.post(url, opts);
  }
  // 复查隐患列表
  public reviewList(opts: object) {
    const url = serverUrl + '/api/yunnan/security-check-hazard/flow-processor/review-list';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  // 复查
  public reviewHazard(opts: object) {
    const url = serverUrl + '/api/yunnan/security-check-hazard/flow-processor/review-hazard';
    return this.rSerivce.serverObj.post(url, opts);
  }

  /*  ↑ 检查考核 -> 整改通知单 ↑  */

  /*  ↓ 检查考核 -> 整改信息补填 ↓ */
  public rectifyInfoSupplement(opts: object) {
    const url = serverUrl + '/api/yunnan/security-check/hazard/supplement-rectify-info';
    return this.rSerivce.serverObj.post(url, opts);
  }
  /*  ↑ 检查考核 -> 整改信息补填 ↑  */

  /*  ↓ 整改单反馈延期 ↓ */
  // 延期
  public delayHazard(opts: object) {
    const url = serverUrl + '/api/yunnan/security-check-hazard/flow-processor/apply-delay';
    return this.rSerivce.serverObj.post(url, opts);
  }
  // 取消延期
  public cancelHazardDelay(opts: object) {
    const url = serverUrl + '/api/yunnan/security-check-hazard/flow-processor/cancel-delay';
    return this.rSerivce.serverObj.post(url, opts);
  }
  // 延期审核列表
  public delayAuditList(opts: object) {
    const url = serverUrl + '/api/yunnan/security-check-hazard/flow-processor/delay-audit-list';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  // 审核延期
  public auditDelay(opts: object) {
    const url = serverUrl + '/api/yunnan/security-check-hazard/flow-processor/audit-delay';
    return this.rSerivce.serverObj.post(url, opts);
  }
  /*  ↑ 整改单反馈延期 ↑  */
  /*  ↓ 综合报表 ↓  */

  // 履职报表
  public getDutyTaskStatisticReport(opts: object) {
    const url = serverUrl + '/api/yunnan/dutyTask/statistic';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  /*  ↑ 综合报表 ↑  */
}
